module.exports = __webpack_public_path__ + "35e487fc657c0e1cc2ac304868cfeb00.svg";